export default "__VITE_ASSET__Lg$DZUqz__"